import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_reimbursed_for_recruitment_fees_and_related_costs_pai'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_reimbursed_for_recruitment_fees_and_related_costs_pai',
  name: 'Are workers reimbursed for recruitment fees and related costs paid?',
  description:
    "The intent of this question is to understand if the facility or any other party reimburses workers for recruitment fees and related costs they may have paid during the recruitment process. \r\r\n\r\r\nFor example, if a worker initially pays for his/her travel from their home country to the facility's country, but then the facility reimburses this cost to workers upon their arrival, answer Yes.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-4--4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5010,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
